export default {
    // Endpoints
    coreRequest: '/core/account/{account_id}/project/{project_id}/dataset/execute?data-index={data-index}&q={query}',
    accountDetails: '/account/{account_id}/details',
    accountUsers: '/account/{account_id}/users',
    accountUserDetails: '/account/{account_id}/user/{account_user_id}',
    accountUserAdd: '/account/{account_id}/user/add',
    accountUserEdit: '/account/{account_id}/user/{account_user_id}/edit',
    accountUserDelete: '/account/{account_id}/user/{account_user_id}/delete',
    userEdit: '/user/{user_id}/edit',
    userChangePassword: '/user/{user_id}/change-password',
    userForgotPassword: '/auth/forget-password',

    // User Segments
    segmentUsers: '/account/{account_id}/project/{project_id}/segment/user',
    segmentUserAdd: '/account/{account_id}/project/{project_id}/segment/add/{segment_type}',
    segmentUserDetails: '/account/{account_id}/project/{project_id}/segment/{segment_type}/{segment_id}',
    segmentUserEdit: '/account/{account_id}/project/{project_id}/segment/{segment_type}/{user_segment_id}/edit',
    segmentUserDelete: '/account/{account_id}/project/{project_id}/segment/user/{user_segment_id}/delete',
    segmentUserMetricComponents: '/account/{account_id}/project/{project_id}/segment/user/metric/component',
    segmentUserDimensionComponents: '/account/{account_id}/project/{project_id}/segment/user/dimension/component',
    previewUserSegment: '/account/{account_id}/project/{project_id}/segment/user/{user_segment_id}/preview',
    publishUserSegment: '/account/{account_id}/project/{project_id}/segment/user/{user_segment_id}/publish',
    unPublishUserSegment: '/account/{account_id}/project/{project_id}/segment/user/{user_segment_id}/unpublished',

    // Page Segments
    segmentPages: '/account/{account_id}/project/{project_id}/segment/page',
    segmentPageAdd: '/account/{account_id}/project/{project_id}/segment/add/{segment_type}',
    segmentPageDetails: '/account/{account_id}/project/{project_id}/segment/{segment_type}/{segment_id}',
    segmentPageEdit: '/account/{account_id}/project/{project_id}/segment/{segment_type}/{page_segment_id}/edit',
    segmentPageDelete: '/account/{account_id}/project/{project_id}/segment/page/{page_segment_id}/delete',
    previewPageSegment: '/account/{account_id}/project/{project_id}/segment/page/{page_segment_id}/preview',
    publishPageSegment: '/account/{account_id}/project/{project_id}/segment/page/{page_segment_id}/publish',
    unPublishPageSegment: '/account/{account_id}/project/{project_id}/segment/page/{page_segment_id}/unpublished',

    // Segment Actions
    segmentActions: '/account/{account_id}/project/{project_id}/segment/action',
    segmentActionAdd: '/account/{account_id}/project/{project_id}/segment/add/{segment_type}',
    segmentActionDetails: '/account/{account_id}/project/{project_id}/segment/action/{action_id}',
    segmentActionEdit: '/account/{account_id}/project/{project_id}/segment/action/{action_id}/edit',
    segmentActionDelete: '/account/{account_id}/project/{project_id}/segment/action/{action_id}/delete',
    // segmentActionComponents: '/account/{account_id}/project/{project_id}/segment/action/component',
    publishSegmentAction: '/account/{account_id}/project/{project_id}/segment/action/{action_id}/publish',
    unPublishSegmentAction: '/account/{account_id}/project/{project_id}/segment/action/{action_id}/unpublish',

    // Project Components
    segmentProjectComponents: '/account/{account_id}/project/{project_id}/segment/project/components',
    accountProjectFilterSearch: '/account/{account_id}/project/{project_id}/filter/{type}/search/{search}',

}
